import { Directive, OnInit, Component, Input, OnChanges, Output } from '@angular/core';
import { AlertMessages, AlertMessage } from '../../_helpers/helperClasses';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'my-alert-view',
  template: `<ol><li *ngFor="let alert of alertMessages.getAlertByType(this.messageType)" class="text-danger"> <span  [innerHTML] ="alert.Message"></span></li></ol>` 
    +`<a class="btn btn-sm btn-danger" *ngIf="alertMessages.getAlertByType(this.messageType).length>0" (click)="makeChanges()">edit</a>`
})
export class AlertHelperViewDirective {

  @Input()
  messageType: string;

  @Input()
  alertMessages: AlertMessages;

  @Output()
  onMakeChanges = new EventEmitter<string>();

  //alerts: AlertMessage[]=[];
  constructor() {
    this.alertMessages = new AlertMessages();
  }

  makeChanges() {
    this.onMakeChanges.emit(this.messageType);
  }

}
